import { Tour } from "../TourProvider.types";

export const TourAccessPersonalSettings: Tour = {
  name: "Access Personal Settings",
  pages: ["home", "organizationProjects", "profile"],
  conditions: {},
  description: "Learn how to access your personal settings.",
  steps: [
    {
      anchorId: "header-user-menu",
      title: "Access your profile",
      content:
        "Use the link in this menu to navigate to your profile page, where you can update your information and preferences.",
    },
    {
      anchorId: "profile-name",
      title: "Update your name",
      content:
        "Change your first and last name as it’s displayed in IDEAS. If you would like to change your email, please contact Inscopix support.",
    },
    {
      anchorId: "profile-avatar",
      title: "Update your avatar",
      content:
        "You can set the colors and initials (max 2 characters) for your avatar, or alternatively upload and use an image.",
    },
    {
      anchorId: "profile-eula",
      title: "View EULA",
      content:
        "Click here to review the EULA that you agreed on when first registering your IDEAS accounts.",
    },
  ],
};
